import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useEffect, useState } from 'react';
export var useDebounceValue = function useDebounceValue(val, delay) {
  var _useState = useState(val),
    _useState2 = _slicedToArray(_useState, 2),
    debounceVal = _useState2[0],
    setDebounceVal = _useState2[1];
  useEffect(function () {
    var handler = setTimeout(function () {
      setDebounceVal(val);
    }, delay);
    return function () {
      clearTimeout(handler);
    };
  }, [val, delay]);
  return debounceVal;
};